import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Features } from '@app/core/user-permissions/user-permissions.model';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';

@Component({
  standalone: false,
  selector: 'sbnb-sidebar-tasks',
  templateUrl: './sidebar-tasks.component.html',
  styleUrls: ['./sidebar-tasks.component.scss'],
})
export class SidebarTasksComponent implements OnInit, OnChanges {
  @Input() tasks: any[];
  @Input() selected: any;
  @Input() date = { date: new Date(), hour: '10' };
  @Input() property: any;

  @Output() taskCreated: EventEmitter<any> = new EventEmitter();
  @Output() taskUpdated: EventEmitter<any> = new EventEmitter();
  @Output() taskDeleted: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();

  creatingTask: boolean;
  perms$ = this.userPermissionsService;
  Features = Features;

  constructor(private userPermissionsService: UserPermissionsService) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selected?.currentValue) {
      this.selected = changes.selected.currentValue;
    } else {
      this.selected = null;
    }
  }

  selectedTask(task) {
    this.selected = task;
  }

  handleTaskCreated(event: any) {
    this.creatingTask = false;
    if (!this.tasks?.length) {
      this.tasks = [];
    }
    this.tasks.push(event);
    this.tasks = [...this.tasks];
    this.taskCreated.emit(event);
  }

  handleTaskUpdated(event: any) {
    this.selected = null;

    const index = this.tasks.findIndex((x) => x.uuid === event.uuid);

    if (index > -1) {
      this.tasks.splice(index, 1);
      this.tasks.push(event);

      this.tasks = [...this.tasks];
    }

    this.taskUpdated.emit(event);
  }

  handleTaskDeleted(uuid: any) {
    this.selected = null;

    const index = this.tasks.findIndex((x) => x.uuid === uuid);

    if (index > -1) {
      this.tasks.splice(index, 1);
      this.tasks = [...this.tasks];
    }

    this.taskDeleted.emit(uuid);
  }

  closeMenu() {
    this.close.emit(true);
  }
}
